<template>
    <div class="order-detail">
        <!-- 页面标题 -->
        <div class="page-header">
            <div class="line"></div>
            <div class="page-title">订单详情</div>
            <el-button type="text" @click="goBack" class="back-btn">返回</el-button>
        </div>

        <!-- 订单状态信息 -->

        <div class="order-status-section">
            <div class="order-status-header">
                <!-- <div class="order-status-text">请等待商家处理</div> -->
                <div class="order-number">订单编号：{{ orderInfo.order_sn || '393432361554830' }}</div>
            </div>
            <div class="order-payment-info">
                <div class="payment-status" v-if="orderInfo.refund_type == '1' || orderInfo.refund_type == '2'">
                    <span class="status-label" v-if="orderInfo.status == 0">待审核</span>
                    <span class="status-label" v-if="orderInfo.status == '1' && orderInfo.express_no == ''">待寄回</span>
                    <span class="status-label" v-if="orderInfo.status < 0">售后关闭</span>
                    <span class="status-label" v-if="orderInfo.status == 1">待寄回</span>
                    <span class="status-label" v-if="orderInfo.status == 2">待退款</span>
                    <span class="status-label" v-if="orderInfo.status == 3">商家已收货</span>
                    <span class="status-label" v-if="orderInfo.status == 4">售后已完成</span>
                    <span class="status-label" v-if="orderInfo.status == '1' && orderInfo.express_no == ''">待退款</span>

                </div>

                <div class="payment-status" v-if="orderInfo.refund_type == '3'">
                    <span class="status-label" v-if="orderInfo.status == 0">待审核</span>
                    <span class="status-label" v-if="orderInfo.status == '1' && orderInfo.express_no == ''">待寄回</span>
                    <span class="status-label" v-if="orderInfo.status == '1' && orderInfo.express_no != ''">待收货</span>

                    <span class="status-label" v-if="orderInfo.status < 0">售后关闭</span>
                    <span class="status-label" v-if="orderInfo.status == 2">待发货</span>
                    <span class="status-label" v-if="orderInfo.status == 4">已发货</span>
                </div>
                <!-- <div class="payment-tips" v-if="orderInfo.status == 0">
                    您已成功发起退货退款申请，请耐心等待商家处理。
                </div> -->
                <div class="payment-actions">
                    <!-- <el-button type="text" class="cancel-btn" @click="openCancelOrderDialog(orderInfo)">撤销申请</el-button> -->
                    <el-button type="text" class="shouhuo-btn" @click="chexiaoCancelOrder(orderInfo)"
                        v-if="(orderInfo.status == '0' || orderInfo.status == '1') && orderInfo.express_no == ''">撤销申请</el-button>

                    <el-button type="text" class="shouhuo-btn" @click="openSendBackDialog(orderInfo)"
                        v-if="orderInfo.status == '1' && orderInfo.refund_type == '2'">填写寄回信息</el-button>

                    <el-button type="text" class="shouhuo-btn" @click="openLogisticsDialog(orderInfo)"
                        v-if="orderInfo.status == '2' && orderInfo.refund_type == '2'">查看物流</el-button>


                    <el-button type="text" class="shouhuo-btn" @click="handleDeleteOrder(orderInfo)"
                        v-if="orderInfo.status <= '0' || orderInfo.status >= '4'">删除订单</el-button>
                </div>
            </div>
        </div>


        <!-- 信息区域 -->
        <div class="info-section-container">
            <div class="info-section">
                <div class="section-header">
                    <span class="section-icon">|</span>
                    <span class="section-title">退款信息</span>
                </div>
                <div class="section-content">
                    <div class="info-item">
                        <span class="info-label">当前状态：</span>
                        <span class="info-value">{{ orderInfo.status_title || '' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">服务类型：</span>
                        <span class="info-value">{{ orderInfo.refund_type_title || '' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">退款原因：</span>
                        <span class="info-value">{{ orderInfo.refund_reason || '' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">退款说明：</span>
                        <span class="info-value">{{ orderInfo.refund_content || '' }}</span>
                    </div>
                    <div class="info-item" style="display: flex;">
                        <span class="info-label">退款凭证：</span>
                        <!-- <img :src="orderInfo.refund_picture || ''" alt=""
                            style="width: 100px;height: 100px;border-radius: 16px;"> -->
                        <el-image :src="orderInfo.refund_picture ? orderInfo.refund_picture[0] : ''"
                            :preview-src-list="orderInfo.refund_picture ? orderInfo.refund_picture : []"
                            v-if="orderInfo.refund_picture && orderInfo.refund_picture.length > 0"
                            style="width: 100px;height: 100px;border-radius: 16px;" fit="cover">
                        </el-image>

                    </div>
                </div>
            </div>
        </div>


        <!-- 商品信息表格 -->
        <table class="goods-table-container">
            <thead class="table-header">
                <tr>
                    <th class="table-title" colspan="2">商品信息</th>
                    <th class="table-column">数量</th>
                    <th class="table-column">商品操作</th>
                    <th class="table-column">金额</th>
                    <!-- <th class="table-column">状态</th> -->
                    <th class="table-column">交易操作</th>
                </tr>
            </thead>

            <!-- 商品列表 -->
            <tbody class="goods-list">
                <tr class="goods-item">
                    <td class="goods-info" colspan="2">
                        <div class="goods-image">
                            <img :src="orderInfo.goods_thumb || ''" alt="商品图片">
                        </div>

                    </td>
                    <td class="goods-operation">
                        <div class="goods-details">
                            <div class="goods-name">{{ orderInfo.goods_name || '' }}</div>
                            <div class="goods-spec">{{ orderInfo.sku_name || '' }}</div>
                            <div class="goods-price">¥{{ orderInfo.shop_price || '' }}/{{ orderInfo.unit || '个' }}
                            </div>
                        </div>
                    </td>

                    <td class="goods-quantity">{{ orderInfo.num || '' }}</td>
                    <td class="goods-operation">
                        <!-- <div class="shouhou-btn" v-if="item.refund_btn.apply_refund == '1' && item.refund_btn.view_refund == 0"
              @click="goShouhou(item)">
              申请售后
            </div>
            <div class="shouhou-btn" v-else-if="item.refund_btn.view_refund == '1' && item.refund_btn.apply_refund == 1"
              @click="goShouhou(item)">
              查看售后详情
            </div>
            <div v-else>-</div> -->
                    </td>
                    <td class="goods-amount">¥{{ orderInfo.goods_money }}</td>
                    <!-- <td class="goods-status">{{ item.order_status_text || '待付款' }}</td> -->
                    <td class="goods-trade-operation">

                        <el-button type="text" size="mini" class="cancel-order-btn"
                            @click="chexiaoCancelOrder(orderInfo)"
                            v-if="(orderInfo.status == '0' || orderInfo.status == '1') && orderInfo.express_no == ''">撤销申请</el-button>

                        <el-button type="text" size="mini" class="cancel-order-btn"
                            v-if="orderInfo.status <= '0' || orderInfo.status >= '4'"
                            @click="handleDeleteOrder(orderInfo)">删除订单</el-button>

                    </td>

                    <!-- <td class="goods-trade-operation">
                        <el-button type="text" size="mini" class="cancel-order-btn"
                            v-if="orderInfo.status <= '0' || orderInfo.status >= '4'"
                            @click="handleDeleteOrder(orderInfo)">删除订单</el-button>
                    </td> -->


                </tr>
            </tbody>
        </table>

        <el-dialog title="物流信息" :visible.sync="logisticsVisible" width="60%" center>
            <ViewLogistics v-if="orderInfo.aid" :orderId="orderInfo.aid" :isAfter="false" :isShouhou="true" />
        </el-dialog>

        <!-- 填写寄回信息弹窗 -->
        <el-dialog title="填写寄回信息" :visible.sync="sendBackDialogVisible" width="640px" :close-on-click-modal="false">
            <div class="send-back-content">
                <!-- 商品信息 -->
                <div class="product-info">
                    <img :src="orderInfo.goods_thumb" alt="商品图片" class="product-image">
                    <div class="product-details">
                        <div class="product-name">{{ orderInfo.goods_name }}</div>
                        <div class="product-sku">{{ orderInfo.sku_name }}</div>
                    </div>
                </div>

                <!-- 提示信息 -->
                <!-- <div class="tip-info">
                    为了给您更优的退换货时效和体验，我公司建议优先选择协作快递顺丰
                </div> -->

                <el-form :model="sendBackForm" label-width="120px" class="send-back-form">
                    <el-form-item label="物流公司">
                        <el-select v-model="sendBackForm.logisticsCompany" placeholder="请选择物流公司" style="width: 100%;">
                            <el-option v-for="company in logisticsCompanies" :key="company.aid" :label="company.name"
                                :value="company.aid"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="物流单号">
                        <el-input v-model="sendBackForm.logisticsNumber" placeholder="请输入物流单号"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="联系人">
                        <el-input v-model="sendBackForm.contactName" placeholder="请输入联系人姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话">
                        <el-input v-model="sendBackForm.contactPhone" placeholder="请输入联系电话"></el-input>
                    </el-form-item> -->
                    <el-form-item label="退货说明">
                        <el-input type="textarea" v-model="sendBackForm.remarks" placeholder="请输入备注信息"
                            :rows="3"></el-input>
                    </el-form-item>

                    <el-form-item label="添加图片">
                        <div class="upload-container">
                            <ImageUpload :image-url="sendBackForm.thumb" :max-files="9"
                                @upload-success="handleImgUpload(2, $event)" />
                            <div class="upload-tips">(图片最多9张)</div>
                        </div>
                    </el-form-item>
                </el-form>

                <!-- 图片上传区域 -->
                <!-- <div class="upload-image-section">
                    <div class="section-title">添加图片</div>
                    <div class="upload-container">
                        <el-upload class="image-uploader" action="#" :auto-upload="false" list-type="picture-card"
                            :limit="5">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                </div> -->
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeSendBackDialog">取 消</el-button>
                <el-button type="primary" style="background-color: #286CED;" @click="submitSendBackInfo">确 定</el-button>
            </span>
        </el-dialog>

    </div>

</template>

<script>
import ViewLogistics from '@/components/ViewLogistics.vue'
import ImageUpload from '@/components/ImageUpload.vue'

export default {
    name: 'ShouhouDetail',
    components: {
        ViewLogistics,
        ImageUpload

    },
    data() {
        return {
            orderInfo: {},
            countdownTime: 0, // 倒计时总秒数
            countdownText: '', // 格式化后的倒计时文本
            countdownInterval: null, // 倒计时定时器

            // 取消订单弹窗相关
            cancelOrderDialogVisible: false,
            selectedCancelReason: '',
            currentOrder: null,
            cancelId: '',
            // 取消订单原因列表
            cancelReasons: [],

            logisticsVisible: false,

            // 填写寄回信息弹窗相关
            sendBackDialogVisible: false,
            sendBackForm: {
                logisticsCompany: '', // 物流公司
                logisticsNumber: '', // 物流单号
                contactName: '', // 联系人
                contactPhone: '', // 联系电话
                remarks: '', // 备注
                thumb: []
            },
            // 物流公司列表
            logisticsCompanies: []
        }
    },
    mounted() {
        this.getOrderDetail()
        this.getLogisticsCompany()
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    },
    methods: {
        goBack() {
            this.$parent.currentComponent = 'OrdersList'
        },

        // 处理图片上传成功事件
        handleImgUpload(type, imageUrl) {
            if (type === 1) {
                this.sendBackForm.thumb = imageUrl[0];
            } else if (type === 2) {
                this.sendBackForm.thumb = imageUrl;
            } else if (type === 3) {
                this.sendBackForm.product_certificate = imageUrl[0];
            }
        },


        // 打开物流弹窗
        openLogisticsDialog() {
            this.logisticsVisible = true;
        },


        // 跳转售后页面
        goShouhou(order) {
            this.$router.push({
                path: '/ShenqingShouhou',
                query: {
                    orderId: order.aid
                }
            })
        },

        // 打开取消订单弹窗
        openCancelOrderDialog(order) {
            this.currentOrder = order;
            this.cancelId = order.aid;
            this.cancelOrderDialogVisible = true;
            this.selectedCancelReason = this.cancelReasons[0].aid || '';
            // this.selectedCancelReason = '1'; // 默认选择第一个原因
        },

        chexiaoCancelOrder(order) {
            let data = {
                id: order.aid,
            };
            this.$api.cancelRefund(data).then(res => {
                this.$message.success('售后申请撤销成功');
                this.cancelOrderDialogVisible = false;
                this.getOrderDetail(); // 重新获取订单详情
            }).catch(err => {
                this.$message.error(err || '售后申请撤销失败');
            });
        },

        // 处理删除订单
        handleDeleteOrder(order) {
            this.$confirm('确定要删除此订单吗？', '删除订单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteOrder(order.aid);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 删除订单
        deleteOrder(orderId) {
            this.$api.deleteRefundOrder({ id: orderId }).then(res => {
                this.$message.success('订单删除成功');
                this.goBack(); // 重新获取订单列表
            }).catch(err => {
                this.$message.error(err || '删除订单失败');
            });
        },

        // 复制订单编号
        copyOrderSn(orderSn) {
            if (!orderSn) {
                this.$message.error('订单编号为空');
                return;
            }
            // 创建临时输入框
            const tempInput = document.createElement('input');
            tempInput.value = orderSn;
            document.body.appendChild(tempInput);
            // 选中并复制
            tempInput.select();
            document.execCommand('copy');
            // 移除临时输入框
            document.body.removeChild(tempInput);
            this.$message.success('订单编号复制成功');
        },

        // 去支付
        handlePay(order) {
            this.$router.push({
                name: 'purchase', // 用 name 跳转，而非 path
                params: {
                    id: order.goods_id,
                    totalPrice: order.payable_money,
                    selectedSkus: order.order_goods_list // 直接传对象/数组
                },
                // 如需保留 query 参数，可加 query
                query: { id: order.goods_id }
            });
        },


        // 获取订单详情
        getOrderDetail() {
            // 从父组件获取订单ID
            const orderId = this.$parent.componentParams ? this.$parent.componentParams.orderId : '';
            if (!orderId) {
                this.$message.error('获取订单ID失败');
                return;
            }
            // 调用API获取订单详情
            this.$api.getShopAfterOrderDetail({ id: orderId }).then(res => {
                this.orderInfo = res;
            }).catch(err => {
                this.$message.error(err || '获取订单详情失败');
                // 如果API调用失败，使用模拟数据初始化倒计时
                // this.initCountdown();
            });
        },


        // 打开填写寄回信息弹窗
        openSendBackDialog() {
            this.sendBackDialogVisible = true;
        },

        // 关闭填写寄回信息弹窗
        closeSendBackDialog() {
            this.sendBackDialogVisible = false;
            // 重置表单
            this.sendBackForm = {
                logisticsCompany: '',
                logisticsNumber: '',
                contactName: '',
                contactPhone: '',
                remarks: ''
            };
        },

        // 获取物流公司列表
        getLogisticsCompany() {
            this.$api.getLogisticsCompany().then(res => {
                this.logisticsCompanies = res || [];
            }).catch(err => {
                this.$message.error(err || '获取物流公司列表失败');
            });
        },

        // 提交寄回信息
        submitSendBackInfo() {
            // 表单验证
            if (!this.sendBackForm.logisticsCompany) {
                this.$message.error('请选择物流公司');
                return;
            }
            if (!this.sendBackForm.logisticsNumber) {
                this.$message.error('请填写物流单号');
                return;
            }
            // if (!this.sendBackForm.contactName) {
            //     this.$message.error('请填写联系人');
            //     return;
            // }
            // if (!this.sendBackForm.contactPhone) {
            //     this.$message.error('请填写联系电话');
            //     return;
            // }

            // 构造提交数据
            const submitData = {
                id: this.orderInfo.aid,
                express_company_id: this.sendBackForm.logisticsCompany,
                express_no: this.sendBackForm.logisticsNumber,
                remark: this.sendBackForm.remarks,
                img: this.sendBackForm.thumb
            };

            // 调用API提交寄回信息
            this.$dapi.submitReturnInfo(submitData).then(res => {
                this.$message.success('寄回信息提交成功');
                this.closeSendBackDialog();
                this.getOrderDetail(); // 重新获取订单详情
            }).catch(err => {
                this.$message.error(err || '寄回信息提交失败');
            });
        }

    }
}
</script>

<style scoped>
.order-detail {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    font-size: 14px;
    color: #333;
}

/* 页面标题 */
.page-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
}

.line {
    width: 4px;
    height: 18px;
    background-color: #286CED;
}

.back-btn {
    margin-left: auto;
    color: #286CED;
}

/* 订单状态区域 */
.order-status-section {
    /* border: 1px solid #e8e8e8; */
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
    /* background-color: #fafafa; */
}

.order-status-header {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.order-status-text {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 5px;
}

.order-number {
    font-size: 12px;
    color: #666;
}

.order-payment-info {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;
    /* border: 1px solid #f0f0f0; */
}

.payment-status {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.status-label {
    font-weight: bold;
    font-size: 16px !important;
    color: #286CED;
    font-size: 12px;
    margin-right: 15px;
}

.countdown {
    color: #666;
    font-size: 12px;
}

.countdown strong {
    color: #ff4d4f;
}

.payment-tips {
    display: flex;
    color: #999;
    font-size: 12px;
    line-height: 1.5;
    margin-bottom: 15px;
}

.payment-actions {
    display: flex;
    justify-content: flex-end;
}

.cancel-btn {
    color: #666;
    margin-right: 10px;
}

.shouhuo-btn {
    background: #F3F3F3;
    padding: 9px 27px;
    color: #333333;
}

.pingjia-btn {
    background-color: #286CED;
    padding: 8px 40px;
    color: #fff;
}

.pingjia-btn-small {
    background-color: #286CED;
    padding: 4px 11px;
    color: #fff;
}

.pay-btn {
    background-color: #286CED;
    border-color: #286CED;
}

.tixing-btn {
    background-color: #fff;
    border-color: #286CED;
    border: 1px solid #286CED;
    color: #286CED;
}

/* 信息区域容器 */
.info-section-container {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.info-section {
    flex: 1;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;
}

.section-header {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #e8e8e8;
}

.section-icon {
    color: #286CED;
    font-weight: bold;
    margin-right: 5px;
}

.section-title {
    font-weight: 500;
    color: #333;
}

.section-content {
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: start;
}

.info-item {
    margin-bottom: 10px;
    line-height: 1.5;
}

.info-label {
    color: #666;
    margin-right: 5px;
}

.info-value {
    color: #333;
}

.copy-btn {
    padding: 0;
    font-size: 12px;
    color: #286CED;
    margin-left: 10px;
}

/* 商品信息表格 */
.goods-table-container {
    width: 100%;
    border-collapse: collapse;
    background-color: #fff;
}

.table-header {
    background-color: #f5f7fa;
}

.table-header th {
    padding: 12px;
    text-align: center;
    font-weight: 500;
    color: #333;
    border-bottom: 1px solid #e8e8e8;
}

.table-title {
    text-align: center;
}

.table-column {
    width: 14.28%;
    /* 7列，每列平均分配宽度 */
}

/* 商品列表 */
.goods-list {
    background-color: #fff;
}

/* 商品项 */
.goods-item td {
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
    text-align: center;
}

.goods-item:last-child td {
    border-bottom: none;
}

.goods-info {
    display: flex;
    align-items: center;
    text-align: left;
}

.goods-image {
    width: 80px;
    height: 80px;
    border: 1px solid #e8e8e8;
    margin-right: 15px;
    overflow: hidden;
}

.goods-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.goods-details {
    flex: 1;
}

.goods-name {
    color: #333;
    margin-bottom: 5px;
    line-height: 1.4;
}

.goods-spec {
    color: #999;
    font-size: 12px;
    margin-bottom: 5px;
}

.goods-price {
    color: #333;
    font-size: 14px;
}

/* 移除固定宽度设置，改为均匀分布 */
.goods-quantity,
.goods-operation,
.goods-amount,
.goods-status {
    width: auto;
    text-align: center;
    color: #333;
    margin: 0;
}

.goods-trade-operation {
    text-align: center;
    margin: 0;
}

.countdown-text {
    display: block;
    color: #ff4d4f;
    font-size: 12px;
    margin-bottom: 5px;
}

.pay-now-btn {
    background-color: #286CED;
    border-color: #286CED;
    margin-bottom: 5px;
    padding: 4px 8px;
    font-size: 12px;
}

.cancel-order-btn {
    padding: 4px 8px;
    font-size: 12px;
    color: #666;
}

/* 订单金额汇总 */
.order-amount-summary {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 15px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    background-color: #fafafa;
}

.summary-item {
    display: flex;
    justify-content: space-between;
    width: 300px;
    margin-bottom: 10px;
    font-size: 14px;
}

.summary-label {
    color: #666;
}

.summary-value {
    color: #333;
}

.summary-item.total {
    font-weight: 500;
    padding-top: 10px;
    border-top: 1px solid #e8e8e8;
    margin-top: 5px;
}

.total-price {
    color: #ff4d4f;
    font-size: 16px;
}

/* 取消订单弹窗样式 */
.cancel-reason-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 20px;
}

.reason-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #333;
    padding: 5px 0;
}

.reason-text {
    text-align: left;
}

.reason-radio {
    text-align: right;
}

/* 隐藏radio组件的默认文本 */
::v-deep .reason-radio .el-radio__label {
    display: none;
}

.dialog-footer {
    display: flex;
    justify-content: center;
    gap: 20px;
}

.shouhou-btn {
    font-size: 14px;
    color: #286CED;
}

/* 填写寄回信息弹窗样式 */
.send-back-content {
    padding: 20px 0;
}

.product-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
}

.product-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    margin-right: 15px;
    border: 1px solid #eee;
    border-radius: 4px;
}

.product-details {
    flex: 1;
}

.product-name {
    display: flex;
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
}

.product-sku {
    display: flex;

    font-size: 12px;
    color: #999;
}

.tip-info {
    display: flex;
    color: #ff4d4f;
    font-size: 12px;
    margin-bottom: 20px;
    padding: 10px;
    background-color: #fff2f0;
    border-radius: 4px;
    border-left: 4px solid #ff4d4f;
}

.send-back-form {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

::v-deep .send-back-form .el-form-item {
    margin-bottom: 20px;
}

.upload-image-section {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.section-title {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    /* margin-bottom: 10px; */
}

.upload-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.image-uploader {
    display: inline-block;
}

::v-deep .image-uploader .el-upload--picture-card {
    width: 100px;
    height: 100px;
    border-radius: 4px;
}

.upload-container {
    /* flex: 1; */
    max-width: 500px;
    display: flex;
    flex-direction: column;
    align-items: start;
}

.upload-container .el-upload--picture-card {
    width: 80px;
    height: 80px;
}

.upload-tips {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
}
</style>